import React from 'react';
import _ from 'underscore';
import { MeControl, CustomMenu } from '@bingads-webui-react/me-control';
import { CustomerSelector } from '@bingads-webui-react/customer-selector';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { withResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import { withPreference } from '@bingads-webui-react/preference-context';

import {
  StyledAccountBreadcrumb,
} from './components';
import { getGlobalMenuStyles } from './styles';
import { GlobalMenuBase } from './global-menu-base';

const GlobalMenuResponsiveSizes = [
  {
    name: 'l',
    minWidth: 0,
  },
  {
    name: 'xl',
    minWidth: 1024,
  },
  {
    name: 'xxl',
    minWidth: 1366,
  },
];

class GlobalMenu extends React.PureComponent {
  render() {
    return (
      <GlobalMenuBase
        {...this.props}
        AccountBreadcrumb={StyledAccountBreadcrumb}
        MeControl={MeControl}
        CustomMenu={CustomMenu}
        CustomerSelector={CustomerSelector}
      />
    );
  }
}

export const StyledGlobalMenu = _.compose(
  _.partial(withDefaultStyles, _, getGlobalMenuStyles),
  withI18nConsumer,
  _.partial(withResponsiveSize, _, GlobalMenuResponsiveSizes),
  withPreference,
  withPermissions
)(GlobalMenu);
